import { PositionType } from "@type/HRM/position";
import {
  getConvertedGradeData,
  getConvertedUnitPositionData,
} from "./baseDataConvert";

export const getFilteredGradeData = (
  positions: PositionType[],
  wing: string,
  designation: string,
  language: string | null | undefined,
  type?: "viewOnly" | "filledPosition",
) => {
  return getConvertedGradeData(
    positions
      .filter((position: PositionType) => {
        const commonCondition =
          position.unit.id === Number(wing) &&
          position.position.id === Number(designation);

        return type === "viewOnly"
          ? commonCondition
          : commonCondition && !position.employee?.id;
      })
      .map((position: PositionType, index: number, self: PositionType[]) => {
        const firstIndex = self.findIndex(
          (p) =>
            p.position.gradeDetails.gradeName ===
            position.position.gradeDetails.gradeName,
        );
        if (firstIndex === index) {
          return {
            ...position.position.gradeDetails,
            name: position.position.gradeDetails.gradeName,
          };
        }
        return null;
      })
      .filter((item: any) => item !== null),
    language,
  );
};

export const getFilteredUnitPositionData = (
  positions: PositionType[],
  wing: string,
  designation: string,
  language: string | null | undefined,
  type?: "viewOnly" | "filledPosition",
) => {
  return getConvertedUnitPositionData(
    positions
      .filter((position: PositionType) => {
        const commonCondition =
          position.unit.id === Number(wing) &&
          position.position.id === Number(designation);

        return type === "viewOnly"
          ? commonCondition
          : commonCondition && !position.employee?.id;
      })
      .map((position: PositionType, index: number, self: PositionType[]) => {
        const firstIndex = self.findIndex(
          (p) =>
            p.unit.id === position.unit.id &&
            p.position.id === position.position.id,
          //  && !p.employee?.id,
        );
        if (firstIndex === index) {
          return position;
        }
        return null;
      })
      .filter((item: any) => item !== null),
    language,
  );
};

export const getFilteredGradeDataForTransfer = (
  positions: PositionType[],
  wing: string,
  designation: string,
  language: string | null | undefined,
  type?: "viewOnly" | "filledPosition",
) => {
  return getConvertedGradeData(
    positions
      // .filter((position: PositionType) => {
      //   const commonCondition =
      //     position.unit.id === Number(wing) &&
      //     position.position.id === Number(designation);

      //   return type === "viewOnly"
      //     ? commonCondition
      //     : commonCondition && !position.employee?.id;
      // })
      .map((position: PositionType, index: number, self: PositionType[]) => {
        const firstIndex = self.findIndex(
          (p) =>
            p.position.gradeDetails.gradeName ===
            position.position.gradeDetails.gradeName,
        );
        if (firstIndex === index) {
          return {
            ...position.position.gradeDetails,
            name: position.position.gradeDetails.gradeName,
          };
        }
        return null;
      })
      .filter((item: any) => item !== null),
    language,
  );
};

export const getFilteredUnitPositionDataForTransfer = (
  positions: PositionType[],
  wing: string,
  designation: string,
  language: string | null | undefined,
  type?: "viewOnly" | "filledPosition",
) => {
  return getConvertedUnitPositionData(
    positions
      // .filter((position: PositionType) => {
      //   const commonCondition =
      //     position.unit.id === Number(wing) &&
      //     position.position.id === Number(designation);

      //   return type === "viewOnly"
      //     ? commonCondition
      //     : commonCondition && !position.employee?.id;
      // })
      .map((position: PositionType, index: number, self: PositionType[]) => {
        const firstIndex = self.findIndex(
          (p) =>
            p.unit.id === position.unit.id &&
            p.position.id === position.position.id,
          //  && !p.employee?.id,
        );
        if (firstIndex === index) {
          return position;
        }
        return null;
      })
      .filter((item: any) => item !== null),
    language,
  );
};
